import { AccountMultiSelectProps } from "./types";
import { AccountName, Check, Empty, List, Option } from "./styles";

export const AccountMultiSelect = ({
  accounts,
  value,
  onChange,
  disabled = false,
  emptyLabel = "No eligible accounts available.",
  labelledBy,
}: AccountMultiSelectProps) => {
  const toggle = (id: number) => {
    if (disabled) {
      return;
    }
    if (value.includes(id)) {
      onChange(value.filter((current) => current !== id));
      return;
    }
    onChange([...value, id]);
  };

  if (accounts.length === 0) {
    return <Empty>{emptyLabel}</Empty>;
  }

  return (
    <List role="group" aria-labelledby={labelledBy}>
      {accounts.map((account) => {
        const selected = value.includes(account.id);
        return (
          <Option
            key={account.id}
            type="button"
            $selected={selected}
            $disabled={disabled}
            disabled={disabled}
            onClick={() => toggle(account.id)}
            aria-pressed={selected}
          >
            <AccountName>{account.name}</AccountName>
            <Check $selected={selected}>{selected ? "✓" : ""}</Check>
          </Option>
        );
      })}
    </List>
  );
};
